import React from "react";
import styles from "./HomePageV2.module.scss";
import "react-multi-carousel/lib/styles.css";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import SectionHome2 from "./SectionHome2";
import SectionHome4 from "./SectionHome4";
import ButtonShop from "./ButtonShop";
import SectionHome3Carrousel from "./SectionHome3Carrousel";
import SectionHome3Mobile from "./SectionHome3Mobile";
import MediaQuery from "react-responsive";

gsap.registerPlugin();

const HomePageV2 = () => {
  useGSAP(() => {});

  return (
    <div className={styles.Wrapp}>
      <header className={styles.headerVideoContainer}>
        <video className={styles.headerVideo} autoPlay muted loop playsInline>
          <source
            src="/videos/_MONAS_video home-1440x1024.mp4"
            type="video/mp4"
          />
          Tu navegador no soporta el video.
        </video>
      </header>

      <ButtonShop />
      <SectionHome2 />
      <MediaQuery minWidth={992}>
        <SectionHome3Carrousel />
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <SectionHome3Mobile />
      </MediaQuery>
      <SectionHome4 />
    </div>
  );
};

export default HomePageV2;
